// Strips HTML tags from a string and returns its plain-text content.
// Legacy test descriptions are stored with HTML markup; display components
// render plain text (or BBCode), so tags must be removed client-side.
export const stripHtmlTags = (htmlString) => {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = htmlString;
    return tmp.textContent || tmp.innerText || '';
};
